<template>
  <!-- 申请购买流程及所需资料 -->
  <div class="apply_info">
    <div class="info_title">申请购买流程及所需资料</div>
    <div class="info_content">
      <img
        src="../../assets/images/applyuse/apply_buy_1.png"
        v-if="isHospital"
        alt=""
      />
      <img v-else src="../../assets/images/applyuse/apply_buy_2.png" alt="" />
      <div class="report_links">
        <div
          class="link_item link_item1"
          @click="downPdf(1)"
          v-if="downObj.applyReportFileName"
        >
          <!-- <a :href="downloadPath + downObj.applyReportFileId " download>下载</a> -->
          下载{{ downObj.applyReportFileName }}
        </div>
        <div
          class="link_item"
          @click="downPdf(2)"
          v-if="downObj.signContractFileName"
        >
          <!-- <a :href="downloadPath + downObj.signContractFileId " download>下载</a> -->
          下载签约合同模板({{ downObj.signContractFileName }})
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  watch: {
    downObj() {
      console.log(this.downObj, "777777");
    },
  },
  computed: {
    ...mapState({
      downloadPath: (state) => state.downloadPath,
    }),
  },
  props: {
    downObj: {
      type: Object,
      default: () => ({}),
    },
    isHospital: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    downPdf(index) {
      this.cnzzStat(
        "服务清单及报价",
        `服务清单及报价页面点击下载申请报告按钮(${this.downObj.applyReportFileId})`,
        "下载申请报告(SE_Key_Application_Template_Downloading)"
      );
      console.log('延时...');
      setTimeout(() => {
        if (index === 1) {
          // console.log(this.downloadPath + this.downObj.applyReportFileId,'路径');
          // return
          // 下载申请模板
          location.href = this.downloadPath + this.downObj.applyReportFileId;
        } else if (index === 2) {
          // 下载合约模板
          //  console.log(this.downloadPath + this.downObj.signContractFileId,'路径');
          //  return
          location.href = this.downloadPath + this.downObj.signContractFileId;
        }
      }, 700);
      //   location.href =
      //     "https://education.gkgzj.com/incontrol-fileserver/file/download/857383fb-1747-405c-b5bc-998b8b4b6569";
    },
  },
};
</script>

<style lang="scss" scoped>
.apply_info {
  min-height: 642px;
  opacity: 1;
  background: #f5f9ff;
  box-sizing: border-box;
  padding: 30px 12px 20px;
  .info_title {
    font-size: 18px;
    margin-bottom: 30px;
    font-family: SourceHanSansCN, SourceHanSansCN-Bold;
    font-weight: 700;
    text-align: center;
    color: #333333;
    line-height: 24px;
  }
  .info_content {
    box-sizing: border-box;
    padding: 46px 10px 20px;
    min-height: 538px;
    opacity: 1;
    background: #ffffff;
    border-radius: 5px;
    img {
      margin: 0 auto 30px;
      width: 231px;
      height: 338px;
    }
    .report_links {
      min-height: 95px;
      opacity: 1;
      background: #f7f8fa;
      border-radius: 5px;
      box-sizing: border-box;
      padding: 20px 10px 20px 18px;
      .link_item {
        text-decoration: underline;
        text-align: left;
        color: #26b4ff;
      }
      .link_item1 {
        margin-bottom: 20px;
      }
    }
  }
}
</style>
